import { styled } from "@mui/material/styles";

const StyledMobileMenu = styled("div")`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
`;

const StyledMobileMenuContainer = styled("div")`
  width: 100%;
  height: 100%;
  max-height: 40%;
  flex: 1;
  padding-top: 32px;
  border-top: 1px solid #d1d9e3;
`;

const StyledMobileMenuNav = styled("ul")`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  list-style-type: none;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

const StyledMobileMenuItem = styled("li")`
  width: max-content;
  box-sizing: border-box;
  padding: 0;
`;

const StyledMobileMenuItemBtn = styled("button")<{ active?: number }>`
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  gap: 16px;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
  line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
  color: ${({ theme, active }) =>
    active === 1 ? theme.palette.common.black : theme.palette.customGrey.dark};
  font-weight: ${({ active }) => (active === 1 ? "500" : "300")};
  cursor: pointer;

  &:hover {
    & .mobile-menu-item__icon > svg {
      stroke: ${({ theme }) => theme.palette.blue.main};
      transition: all 0.15s linear;
    }
  }

  &:disabled {
    color: ${({ theme }) => theme.palette.customGrey.main};

    & .mobile-menu-item__icon > svg {
      stroke: ${({ theme }) => theme.palette.customGrey.main};
    }
  }
`;

const StyledMobileMenuItemIcon = styled("span")`
  height: 22px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  & > svg {
    width: 100%;
    stroke: ${({ theme }) => theme.palette.customGrey.dark};
    transition: all 0.15s linear;
  }
`;

const StyledMobileMenuSwitchItem = styled("li")`
  width: max-content;
  padding: 0;
  user-select: none;
  max-width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  gap: 16px;
  background: transparent;
  transition: all 0.3s linear;
  flex-shrink: 0;
  cursor: pointer;
  text-align: left;
  cursor: default;

  & > .mobile-menu-switch__text {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
    line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
    color: ${({ theme }) => theme.palette.customGrey.dark};
    font-weight: 300;
    white-space: nowrap;
  }
`;

const StyledMobileMenuFooter = styled("div")`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  padding-top: 32px;
  gap: 24px;
  border-top: 1px solid #d1d9e3;
  transition: all 0.3s linear;
`;

const StyledMobileMenuUser = styled("button")`
  width: max-content;
  max-width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  gap: 16px;
  border: none;
  outline: none;
  background: transparent;
  transition: all 0.3s linear;
  flex-shrink: 0;
  padding: 0;
  transition: padding 0.3s linear;
  cursor: pointer;
  text-align: left;
`;

const StyledMobileMenuUserInfo = styled("div")`
  max-width: 190px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.common.black};
  user-select: none;
`;

const StyledMobileMenuLogOutBtn = styled("button")`
  width: max-content;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
  line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
  color: ${({ theme }) => theme.palette.customGrey.dark};
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;

  & > .log-out-btn__icon {
    height: 22px;
    width: 22px;
    min-width: 22px;

    & > svg {
      width: 100%;
      stroke: ${({ theme }) => theme.palette.customGrey.dark};
      transition: all 0.15s linear;
    }
  }

  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.palette.blue.main};

    & svg {
      stroke: ${({ theme }) => theme.palette.blue.main};
      transition: all 0.15s linear;
    }
  }
`;

const StyledMobileMenuVersionContainer = styled("div")`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
`;

export {
  StyledMobileMenu,
  StyledMobileMenuContainer,
  StyledMobileMenuNav,
  StyledMobileMenuItem,
  StyledMobileMenuItemBtn,
  StyledMobileMenuItemIcon,
  StyledMobileMenuSwitchItem,
  StyledMobileMenuFooter,
  StyledMobileMenuUser,
  StyledMobileMenuUserInfo,
  StyledMobileMenuLogOutBtn,
  StyledMobileMenuVersionContainer,
};
